// removed by extract-text-webpack-plugin
module.exports = {"block":"PreloaderScreen__block-3cDJS"};